import React from "react";
import { Link } from "react-router-dom";
import { COMMODITY_TABS } from "../mock";

export default function CommodityTabs({ active, variant = "dark" }) {
  const dark = variant === "dark";
  return (
    <nav
      className={`inline-flex items-center gap-1 rounded-full p-1.5 border backdrop-blur-md ${dark ? "bg-[#10271a]/55 border-[#f6f1e7]/15" : "bg-[#10271a]/5 border-[#10271a]/10"}`}
      aria-label="Commodity"
      data-testid="commodity-tabs"
    >
      {COMMODITY_TABS.map((t) => {
        const isActive = t.id === active;
        return (
          <Link
            key={t.id}
            to={`/trading/${t.id}`}
            data-testid={`tab-${t.id}`}
            aria-current={isActive ? "page" : undefined}
            className={`px-5 md:px-7 py-2.5 rounded-full text-[12px] md:text-[13px] tracking-[0.14em] uppercase font-semibold transition-colors duration-300 ${
              isActive
                ? dark ? "bg-[#f6f1e7] text-[#10271a]" : "bg-[#1f4a33] text-[#f6f1e7]"
                : dark ? "text-[#f6f1e7]/80 hover:text-[#f6f1e7] hover:bg-[#f6f1e7]/10" : "text-[#10271a]/70 hover:text-[#10271a] hover:bg-[#10271a]/5"
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
